import { AdditionalInputs } from '../interfaces/Types';

export class LoggingHelper {
  static buildExtraBuildingData = (additionalInputs?: AdditionalInputs[]) => {
    const extraBuildingData: any = [];
    if (additionalInputs && additionalInputs?.length > 0) {
        additionalInputs.map((item: AdditionalInputs) => {
            extraBuildingData.push({
            area: item.area.value,
            type: item.type.label,
            waterEnergyType: item.energyType.label
            });
      });
    }
    return extraBuildingData;
  }

}
